import { weightToKg } from "./Anthropometry";
export const roundMacros = ({ cho, pro, fat, kcal }) => ({
    cho: Math.round(cho),
    pro: Math.round(pro),
    fat: Math.round(fat),
    kcal: Math.round(kcal),
});
export const scaleMacros = ({ cho, pro, fat, kcal }, amount) => ({
    cho: cho * amount,
    pro: pro * amount,
    fat: fat * amount,
    kcal: kcal * amount,
});
export const getMacrosInput = (macros) => {
    return { cho: macros.cho, pro: macros.pro, fat: macros.fat };
};
export const addMacros = (ma1, ma2) => ({
    cho: ma1.cho + ma2.cho,
    pro: ma1.pro + ma2.pro,
    fat: ma1.fat + ma2.fat,
    kcal: ma1.kcal + ma2.kcal,
});
export const sumMacros = (macros) => macros.reduce(addMacros, ZERO_MACROS);
export const ZERO_MACROS = {
    cho: 0,
    pro: 0,
    fat: 0,
    kcal: 0,
};
export const ZERO_MACROS_INPUT = {
    cho: 0,
    pro: 0,
    fat: 0,
};
export const maybeMacrosToMacros = ({ cho, pro, fat, kcal }) => ({
    cho: cho || 0,
    pro: pro || 0,
    fat: fat || 0,
    kcal: kcal || 0,
});
export const initMacros = (cho, pro, fat) => ({ cho, pro, fat, kcal: getCalories(cho, pro, fat) });
export const getMacrosHash = ({ cho, pro, fat, kcal }) => `cho:${cho},pro:${pro},fat${fat},kcal${kcal}`;
export const macrosAreEqual = (macros1, macros2) => getMacrosHash(macros1) === getMacrosHash(macros2);
//
// Calories per gram
//
export const getMacroCaloriesPerGram = (macro) => {
    switch (macro) {
        case "cho":
        case "pro":
            return 4;
        case "fat":
            return 9;
        default:
            return 0;
    }
};
export const getCalories = (cho, pro, fat) => cho * getMacroCaloriesPerGram("cho") + pro * getMacroCaloriesPerGram("pro") + fat * getMacroCaloriesPerGram("fat");
export const getMacrosCalories = ({ cho, pro, fat }) => getCalories(cho, pro, fat);
export const getMacrosCaloriesRounded = (macros) => Math.round(getMacrosCalories(macros));
export const getCaloriesPerMacro = ({ cho, pro, fat }) => ({
    cho: getMacroCaloriesPerGram("cho") * cho,
    pro: getMacroCaloriesPerGram("pro") * pro,
    fat: getMacroCaloriesPerGram("fat") * fat,
    kcal: 0,
});
//
// MacroMath specific
//
export const macroMathLeftOverRatioTotal = (cho, pro, fat) => cho.leftOverRatio + pro.leftOverRatio + fat.leftOverRatio;
//
// MacroTarget specific
//
export const macroTargetPercentTotal = (cho, pro, fat) => cho.percent + pro.percent + fat.percent;
//
// MacroMath/MacrosTarget shared gPerKg
//
export const gPerKgToGrams = (gPerKg, weight) => gPerKg * weightToKg(weight);
export const gPerKgToCalories = (gPerKg, weight, macro) => gPerKgToGrams(gPerKg, weight) * getMacroCaloriesPerGram(macro);
export const macroGPerKgToGrams = (macro, weight) => gPerKgToGrams(macro.gPerKg, weight);
export const macroGPerKgToGramsRounded = (macro, weight) => Math.round(macroGPerKgToGrams(macro, weight));
export const macroGPerKgToGramsMacros = (cho, pro, fat, weight) => initMacros(macroGPerKgToGrams(cho, weight), macroGPerKgToGrams(pro, weight), macroGPerKgToGrams(fat, weight));
export const macroGPerKgToGramsMacrosRounded = (cho, pro, fat, weight) => roundMacros(macroGPerKgToGramsMacros(cho, pro, fat, weight));
export const macroGPerKgCaloriesTotal = (cho, pro, fat, weight) => getMacrosCalories(macroGPerKgToGramsMacros(cho, pro, fat, weight));
export const macroGPerKgCaloriesTotalRounded = (cho, pro, fat, weight) => Math.round(macroGPerKgCaloriesTotal(cho, pro, fat, weight));
//
// Metric Update
// alternative implementation could be to pass isMetric around until calculations reach weightToKg()
//
export const macroMetricGPerKgToGramsRounded = (macro, weightInKg) => Math.round(macro.gPerKg * weightInKg);
export const metricGPerKgToCalories = (gPerKg, weightInKg, macro) => gPerKg * weightInKg * getMacroCaloriesPerGram(macro);
export const macroGPerKgToGramsMetricMacros = (cho, pro, fat, weightInKg) => initMacros(cho.gPerKg * weightInKg, pro.gPerKg * weightInKg, fat.gPerKg * weightInKg);
export const macroGPerKgCaloriesMetricTotal = (cho, pro, fat, weightInKg) => getMacrosCalories(macroGPerKgToGramsMetricMacros(cho, pro, fat, weightInKg));
export const macroGPerKgCaloriesMetricTotalRounded = (cho, pro, fat, weightInKg) => Math.round(macroGPerKgCaloriesMetricTotal(cho, pro, fat, weightInKg));
export const macroGPerKgToGramsMetricMacrosRounded = (cho, pro, fat, weightInKg) => roundMacros(macroGPerKgToGramsMetricMacros(cho, pro, fat, weightInKg));
//# sourceMappingURL=Macros.js.map